import { useAppSelector } from 'app/hooks';
import { AxiosError } from 'axios';
import AlertModal from 'components/common/AlertModal';
import FeatureTitleBar from 'components/common/FeatureTitleBar';
import useGlobalModal from 'components/common/GlobalModal/useGlobalModal';
import { selectIsEditMode } from 'features/common/editModeSlice';
import { CONST_DEL_GENRE_FILTER } from 'features/Genre/constans';
import { Genre } from 'features/Genre/models/Genre';
import AddModal from 'features/Genre/pages/add/AddModal';
import service from 'features/Genre/pages/list/services';
import { useEffect, useState } from 'react';
import { Card, Col, Modal, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { handleServiceError } from 'utils';
import Filter from './components/Filter';
import TableList from './components/TableList';
import './style.scss';

export interface GenreAddModalReturnData {
  selectedGenres: Array<{ id: number; name: string }>;
}

export interface GenreAddModalProps {
  isShowModal: boolean;
  exceptGenreIds?: number[];
  onReflect?: (returnData: GenreAddModalReturnData) => void;
  onClose: () => void;
}

function GenreAddModal({ isShowModal, exceptGenreIds = [], onReflect, onClose }: GenreAddModalProps) {
  const { showGlobalModal } = useGlobalModal();
  const [nameGenre, setNameGenre] = useState('');
  const [dataTable, setDataTable] = useState<Genre[] | []>();
  const [showAddModal, setShowAddModal] = useState(false);

  // selectors
  const isEditMode = useAppSelector(selectIsEditMode);

  // call API
  async function filterAPI(name: string) {
    await service
      .getGenres(name, CONST_DEL_GENRE_FILTER.ALL)
      .then((result) => {
        const dataFilter = result.data.filter((genre: Genre) => {
          if (!exceptGenreIds?.includes(genre.id)) {
            return genre;
          } else {
            return null;
          }
        });
        setDataTable(dataFilter);
      })
      .catch((error) => {
        if (!handleServiceError(showGlobalModal, error as AxiosError)) {
          showGlobalModal(() => (
            <AlertModal title={t('Genre.Validator.error')} message={JSON.stringify(error.response.data.data)} />
          ));
        }
      });
  }

  // first load page
  useEffect(() => {
    async function getDataTable(name: string) {
      filterAPI(name).catch((error) => {
        if (!handleServiceError(showGlobalModal, error as AxiosError)) {
          showGlobalModal(() => (
            <AlertModal title={t('Genre.Validator.error')} message={JSON.stringify(error.response.data.data)} />
          ));
        }
      });
    }
    getDataTable(nameGenre).catch((error) => {
      if (!handleServiceError(showGlobalModal, error as AxiosError)) {
        showGlobalModal(() => (
          <AlertModal title={t('Genre.Validator.error')} message={JSON.stringify(error.response.data.data)} />
        ));
      }
    });
    /* eslint-disable react-hooks/exhaustive-deps */
  }, []);

  // search name
  function callFilter() {
    filterAPI(nameGenre).catch((error) => {
      if (!handleServiceError(showGlobalModal, error as AxiosError)) {
        showGlobalModal(() => (
          <AlertModal title={t('Genre.Validator.error')} message={JSON.stringify(error.response.data.data)} />
        ));
      }
    });
  }

  function handleClose() {
    onClose && onClose();
  }
  const { t } = useTranslation();

  function handleChangeName(event: React.ChangeEvent<HTMLInputElement>) {
    setNameGenre(event.target.value);
  }

  function handleCloseModalAdd(status: boolean) {
    setShowAddModal(false);
    if (status) callFilter();
  }

  function handleOnClickAddGenre() {
    setShowAddModal(true);
  }
  function handleBtnOnReflect(selectedGenres: Array<{ id: number; name: string }>) {
    onReflect && onReflect({ selectedGenres });
  }

  return (
    <Modal show={isShowModal} backdrop="static" onHide={handleClose} centered>
      <Modal.Header closeButton className={isEditMode ? 'reedit-mode-wrapper' : ''}>
        <FeatureTitleBar title={t('GenreAddModal.title')} />
      </Modal.Header>
      <Modal.Body className={isEditMode ? 'reedit-mode-wrapper' : ''}>
        <Filter handleChangeName={handleChangeName} name={nameGenre} callFilter={callFilter} />
        <Row>
          <Col md={{ span: 6 }}></Col>
          <Col md={{ offset: 12 }}>
            <button className="pull-right html-link py-3" onClick={handleOnClickAddGenre} style={{ cursor: 'pointer' }}>
              {t('GenreAddModal.link_to')}
            </button>
            <AddModal show={showAddModal} handleCloseModalAdd={handleCloseModalAdd} />
          </Col>
        </Row>
        <Card className="border-0 p-3">
          {dataTable && (
            <TableList
              dataTable={dataTable}
              handleBtnOnReflect={handleBtnOnReflect}
              setDataTable={setDataTable}
              exceptGenreIds={exceptGenreIds}
            />
          )}
        </Card>
      </Modal.Body>
    </Modal>
  );
}
export default GenreAddModal;
